export const PLACEHOLDER_IMAGE = '/placeholder-image.svg';

/** Swap broken /public/* URLs to a local SVG once (avoids infinite loop). */
export function onPublicImageError(e) {
  const el = e.currentTarget;
  if (el.dataset.fallback === '1') return;
  el.dataset.fallback = '1';
  el.src = PLACEHOLDER_IMAGE;
}
